import { FC } from 'react'
import { useDispatch } from 'react-redux'

import { IconButton, Theme } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/pro-solid-svg-icons'

import makeStyles from '@mui/styles/makeStyles'

import { closeSnackbar } from 'store/notifier'
import { VariantType } from 'notistack'
import { useTheme } from '@mui/styles'
import { getIconColor } from './helper'

const useStyles = makeStyles((theme: Theme) => ({
  closeButton: {
    position: 'absolute',
    top: 0,
    right: 8
  }
}))

type Props = {
  enqKey: string | number
  variant?: VariantType
}
const CloseBtnEnq: FC<Props> = ({ enqKey, variant }) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const theme = useTheme()
  const closeSnack = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    event.stopPropagation()
    dispatch(closeSnackbar(enqKey))
  }
  return (
    <IconButton
      size='small'
      onClick={(event) => closeSnack(event)}
      data-py-id='dismissNotifier'
      className={classes.closeButton}
    >
      <FontAwesomeIcon icon={faTimes} color={getIconColor(theme, variant)} />
    </IconButton>
  )
}

const closeAction = (enqKey: string | number, variant?: VariantType) => {
  return <CloseBtnEnq enqKey={enqKey} variant={variant} />
}

export default closeAction
